import { useAccountStore, useUserStore } from "base/stores";
import { getS3FileKey } from "base/utils";

import { createWithImmer } from "./index.js";
import { AdminService } from "../services/index.js";

export let initialSAMLSetting = {
  SignOnUrl: "",
  FingerPrint: "",
  FieldId: "Email",
  CreateUser: false,
  SCIM: {}
};

let _owner = window.accountDetails?.UserDetails?.AccountDetails?.Owner;

const ADMIN_INITIAL_DATA = {
  domainName: "",
  domainAddress: "",
  domainVerifyEmail: "",
  domainInfo: {},
  error: {},
  AuthType: {},
  AssociatedEmailDomains: [],
  WeekEnds: [],
  holidayList: [],
  Year: new Date().getFullYear(),
  holidayInfo: {},
  AuthSettings: initialSAMLSetting,
  Owner: _owner,
  adminLoader: false,
  errorMsg: {}
};

let { update: accountUpdate } = useAccountStore.getState();
let { update: userStoreUpdate } = useUserStore.getState();

export const useAdminStore = createWithImmer("admin", (set) => ({
  ...ADMIN_INITIAL_DATA,
  isThemeInputChanged: false,
  hasUnsavedWork: false,
  isAdmin: true,

  setAuthType: (type) => {
    set((draft) => {
      draft.AuthType[type] = !!type;
    });
  },

  setAccountSubMenu: (menu) => {
    set((state) => {
      state.selectedSubMenu = menu;
    });
  },

  setThemeInput: (data) => {
    set((draft) => {
      return { ...draft, isThemeInputChanged: data };
    });
  },

  setBotSettings: (setting) => {
    set((draft) => {
      return { ...draft, BotPreference: setting };
    });
  },

  setUnSavedWorkStatus: (status) => {
    set((draft) => {
      return { ...draft, hasUnsavedWork: status };
    });
  },

  resetSAML: () => {
    set((draft) => {
      return { ...draft, AuthSettings: initialSAMLSetting };
    });
  },

  updateAccountOwner: (value) => {
    set((state) => {
      state.Owner = value;
    });
  },

  updateAccountData: (data) => {
    let [accountIdReq] = AdminService.getAccountDetails();

    useAdminStore.setState({
      ...data
    });

    accountIdReq()
      .then((res) => {
        if (res.CompanyLogo) {
          res.CompanyLogo.url = `${
            res.AppConfig.ProfileBasePath
          }/${getS3FileKey(res.CompanyLogo.Rectangle.key)}`;
        }

        let language = res.UserDetails?.Language || res.Language;

        accountUpdate((store) => {
          Object.assign(store, { ...res, Language: language });
        });

        window.accountDetails = {
          ...window.accountDetails,
          ...res,
          Language: language
        };

        // Update userstore
        if (res.UserDetails) {
          userStoreUpdate((draft) => {
            draft.currentUser = res.UserDetails;
          });
        }
      })
      .catch((err) => console.warn("Error in fetching account details", err));
  },

  setApiBaseUrl: (url) => {
    set((state) => {
      state.apiBaseUrl = url;
    });
  },

  resetState: () => set(() => ADMIN_INITIAL_DATA)
}));
